import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { LocationControllerApi } from '../api/generated';
import type { LocationResponse } from '../api/generated';
import { createApiConfiguration } from '../api/apiConfig';
import ROUTES from '../routes/routeConstants';
import { LocationCard } from '../components/LocationCard/LocationCard';
import styles from './LocationsPage.module.css';

export const LocationsPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [locations, setLocations] = useState<LocationResponse[]>([]);

  useEffect(() => {
    const fetchLocations = async () => {
      try {
        const api = new LocationControllerApi(createApiConfiguration());
        const response = await api.getLocations();
        setLocations(response.data);
      } catch (error) {
        console.error('Failed to load locations:', error);
        navigate(`/${ROUTES.errorPage}`);
      }
    };
    fetchLocations();
  }, [navigate]);

  return (
    <main className={styles.locations}>
      <h1 className={styles.heading}>{t('locations-header')}</h1>
      <div className={styles.cardList}>
        {locations.map((location) => (
          <LocationCard key={location.id} id={location.id} name={location.name} />
        ))}
      </div>
    </main>
  );
};
